var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { staticClass: "top-menu", attrs: { row: "" } },
    [
      _vm.$mdAndUpResolution
        ? _c(
            "v-flex",
            { attrs: { sm4: "" } },
            [
              _vm.$mdAndUpResolution
                ? _c(
                    "v-btn",
                    {
                      directives: [
                        {
                          name: "smart-tooltip",
                          rawName: "v-smart-tooltip",
                          value: {
                            show: _vm.showSettingsTooltip,
                            text: _vm.$t("topMenu.settingsTooltip"),
                            position: "left",
                            dark: true,
                            showOnce: true,
                            name: "settingsTooltip"
                          },
                          expression:
                            "{show: showSettingsTooltip, text: $t('topMenu.settingsTooltip'), position: 'left', dark: true, showOnce: true, name: 'settingsTooltip'}"
                        }
                      ],
                      staticClass: "no-padding",
                      attrs: { flat: "" },
                      on: { click: _vm.settingsClicked }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            title: _vm.$t("topMenu.openSettings"),
                            color: "dark",
                            medium: _vm.$lowResolution
                          }
                        },
                        [_vm._v("settings")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$mdAndUpResolution
        ? _c(
            "v-flex",
            { attrs: { sm4: "" } },
            [_c("floating-menu", { staticClass: "no-padding" })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.$mdAndUpResolution
        ? _c(
            "v-flex",
            [
              _c("floating-menu", {
                staticClass: "no-padding",
                attrs: { "show-settings": "", "open-on-hover": false }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { sm4: "" } },
        [
          _vm.$mdAndDownResolution
            ? _c(
                "v-btn",
                {
                  staticClass: "no-padding",
                  attrs: { flat: "" },
                  on: {
                    click: function($event) {
                      return _vm.toggleSidebarIsPinned()
                    }
                  }
                },
                [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        title: _vm.$t("topMenu.pinSidebar"),
                        medium: _vm.$lowResolution,
                        color: _vm.isPinned ? "primary" : "dark"
                      }
                    },
                    [_vm._v("\n        lock")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { sm4: "" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "no-padding pr2",
              attrs: { flat: "" },
              on: {
                click: function($event) {
                  return _vm.toggleSidebar()
                }
              }
            },
            [
              _c(
                "v-icon",
                {
                  attrs: {
                    title: _vm.$t("global.close"),
                    color: "dark",
                    medium: _vm.$lowResolution
                  }
                },
                [_vm._v("close ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14c566a6", { render: render, staticRenderFns: staticRenderFns })
  }
}